<template>
	<div>
		<a-row class="">
			<div class="flex mt15 mb15" style="justify-content: space-between;">
                <div class="flex items-center">
                    <a-button size="small" class="ml10" type="primary" @click="back" >返回</a-button>
                    <img class="ml15 mr10" src="../../../public/images/guigeguanli.png" style="width:25px;height:25px" />
                    <div class="ml0 fs14" style="color:grey">供应商报价链接表</div>
                </div>
            
                <div class="mr20 flex" style=""> 
                    <a-select size="small" v-model:value="select_project_id" style="width: 200px">
                        <a-select-option v-for="item in projects" :key="item.key" :value="item.id">
                            {{ item.name }}
                        </a-select-option>
                    </a-select>
                    <a-input-search size="small" allowClear class="ml10" v-model="search" placeholder="请输入关键字" enter-button @change="allowCostClear" @search="onSearch" @pressEnter="onSearch"/>
                </div>
            </div>
		</a-row>
		
		<a-row :gutter="24" type="flex" align="stretch">
			<a-col :span="24" :lg="30" class="mb-24">
				<a-card :bordered="false" class="header-solid h-full" :bodyStyle="{padding: 0,}">
					<a-table :data-source="data" :columns="columns" class="pd15"  :pagination="false"  size="small" bordered>
                        <template slot="link" slot-scope="text,record">
                            <a @click="goLink(text)">{{ text }}</a>	
                        </template>
					</a-table>
					<a-pagination 
						class="flex items-center mb10"
						style="justify-content: flex-end"
						show-quick-jumper  
						v-model="page.page" 
						:total="page.total" 
                        :page-size="30"
						@change="getSupplierOfferLinkList" 
					/>
				</a-card>
			</a-col>
		</a-row>
		
	</div>
</template>

<script>
	export default ({
		components: {

		},
		data() {
			return {
				columns:[
					{
                        title: '序号',
                        dataIndex: 'id',
                        key: 'id',
                    },
                    {
                        title: '项目名称',
                        dataIndex: 'project_name',
                        key: 'project_name',
                    },
                    {
                        title: '供应商',
                        dataIndex: 'supplier_name',
                        key: 'supplier_name',
                    },
                    {
                        title: '物资',
                        dataIndex: 'show_material',
                        key: 'show_material',
                    },
                    {
                        title: '链接',
                        dataIndex: 'link',
                        key: 'link',
                        scopedSlots: { customRender: 'link' },
                    },
                    {
                        title: '创建时间',
                        dataIndex: 'create_time',
                        key: 'create_time',
                    },
					// {
                    //     title: '操作',
                    //     dataIndex: 'operation',
                    //     key: 'operation',
                    //     scopedSlots: { customRender: 'operation' },
                    // },
				],
				data:[],
				page:{page:1,total:0},
				search:"",
                select_project_id:-1,
				projects:[],
   
			}
		},
        onload(){

        },
		created(){
            this.getSupplierOfferLinkList()
            this.getProjectList()
		},
		methods:{
			async getSupplierOfferLinkList(){
				let rs = await this.$api.getSupplierOfferLinkList(this.select_project_id, this.search, this.page.page - 1, 10)
				if(rs.err == 0){
                    for(let item of rs.data){
                        item.link = `https://build.genyun2019.cn/#/bj/${item.supplier_name}/${item.key}`
                        item.show_material = ""
                        item.material = JSON.parse(item.material)
                        for(let part of item.material){
                            item.show_material = (item.show_material == "")?part.name:(item.show_material + "、" + part.name)
                        }
                    }
					this.data = rs.data
					this.page.total = rs.count
				}
			},
            async getProjectList() {
                let rs = await this.$api.getProjectList(0, 10000);
                console.log(rs.data)
                if (rs.err == 0) {
                    for (let item of rs.data) {
                        item.key = item.id + "";
                    }
                    let as = {id:-1, key:"-1", name:"全部"}
                    this.projects = rs.data;
                    this.projects.push(as)
                }
            },
			onSearch(){
                this.page.page = 1
                this.getSupplierOfferLinkList()
			},
			allowCostClear(){
                this.page.page = 1;
                this.getSupplierOfferLinkList()
            },
            goLink(text){
                window.location.href = text;
            },
            back(){
                window.history.back()
            }		
        }
	})

</script>

<style scoped>
.editable-row-operations a {
  margin-right: 8px;
}
</style>